/*
 * ******************************************************************
 * Copyright (c) 2021-2025 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */
import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from "@angular/core";
import { RbacService } from "@app/services";

// @formatter:off
@Directive({
    standalone: false,
    selector: "[requiredRole]"
})
// @formatter:on
export class RequiredRoleDirective implements OnInit {
    private _requiredRole: string;
    private _hideIfPresent: boolean = false;

    constructor(private templateRef: TemplateRef<any>,
                private viewContainer: ViewContainerRef,
                private rbacService: RbacService) {
    }

    @Input()
    set requiredRole(role: string) {
        this._requiredRole = role;
    }

    @Input()
    set requiredRoleHideIfPresent(value: boolean) {
        this._hideIfPresent = value;
    }

    ngOnInit(): void {
        this.showControl(this.rbacService.hasRole(this._requiredRole) && !this._hideIfPresent);
    }

    private showControl(visible: boolean) {
        if (visible) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }
}
